import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exportar',
  templateUrl: './exportar.component.html',
  styleUrls: ['./exportar.component.scss']
})
export class ExportarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
